<template>
    <b-container fluid class='home-container p-0'>
        <NavBar/>
        <router-view></router-view>
        <Footer/>
    </b-container>
</template>

<script>
    import NavBar from '@/components/Navbar'
    import Footer from '@/components/Footer'

    export default {
        name: 'Home',
        components: {
            NavBar, Footer
        },
        methods: {}
    }
</script>
<style scoped>
</style>
